<template>
  <div class="workbench-content" v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(255, 255, 255, 0.3)">
    <div class="header-row">
      <div class="page-title">
        <img :src="iconImg" class="title-icon" />
        <span class="main-title">新品上架</span>
        <div class="title-decoration">
          <img :src="titleImg" class="title-decoration-img" />
        </div>
        <div class="tab-wrapper">
          <div class="tab-item" v-for="(tab, index) in storeTabs" :key="index" :class="{ active: activeTab === index }" @click="handleTabClick(tab, index)">
            {{ tab.storeName }}
          </div>
        </div>
      </div>
    </div>

    <div class="cards-row">
      <div class="card-item" v-for="(item, index) in cardsData" :key="index" @click="handleCardClick(item)">
        <div class="card-title-row"></div>
        <div class="card-content">
          <div class="card-number" :class="item.color">{{ item.value || 0 }}</div>
          <div class="card-sub">{{ item.title }}</div>
        </div>
      </div>
    </div>

    <div class="tables-row">
      <div class="table-group">
        <div class="table-box table-box-with-header">
          <div class="panel-header">
            <span class="panel-title">店铺平均耗时排名</span>
            <el-tooltip
              content="耗时统计为店铺下汇总相加各商品的（操作无需上架或已上架的时间 – 商品发布时间） /  商品数，并根据各店铺的平均耗时进行统计数据排名；"
              placement="top"
            >
              <i class="el-icon-question help-icon"></i>
            </el-tooltip>
          </div>
          <div class="panel-content">
            <div class="table-header-row">
              <span class="th name">店铺</span>
              <span class="th value">耗时天数</span>
              <span class="th rank">排名</span>
            </div>
            <div class="table-body">
              <div
                class="table-row"
                v-for="item in leftTableData.slice(0, 5)"
                :key="item.rank"
                :class="{ 'highlight-row': item.storeName === currentStoreName }"
              >
                <span class="td name">{{ item.storeName }}</span>
                <span class="td value">{{ item.days }}</span>
                <span class="td rank">{{ item.rank }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-box table-box-no-header">
          <div class="panel-content">
            <div class="table-body body-right" v-if="leftTableData.length > 5">
              <div
                class="table-row"
                v-for="item in leftTableData.slice(5, 10)"
                :key="item.rank"
                :class="{ 'highlight-row': item.storeName === currentStoreName }"
              >
                <span class="td name">{{ item.storeName }}</span>
                <span class="td value">{{ item.days }}</span>
                <span class="td rank">{{ item.rank }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table-group">
        <div class="table-box table-box-with-header">
          <div class="panel-header">
            <span class="panel-title">店铺待上架商品数排名</span>
            <el-tooltip content="根据各店铺的待上架商品进行统计数据排名；" placement="top">
              <i class="el-icon-question help-icon"></i>
            </el-tooltip>
          </div>
          <div class="panel-content">
            <div class="table-header-row">
              <span class="th name">店铺</span>
              <span class="th value">待上架总数</span>
              <span class="th rank">排名</span>
            </div>
            <div class="table-body">
              <el-tooltip
                v-for="item in rightTableData.slice(0, 5)"
                :key="item.rank"
                effect="light"
                placement="top"
                :open-delay="500"
                popper-class="shooting-tooltip"
              >
                <div slot="content" class="tooltip-content">
                  <div class="tooltip-item">
                    <div class="tooltip-label">延期待上架</div>
                    <div class="tooltip-value">{{ item.delayQty || 0 }}</div>
                  </div>
                  <div class="tooltip-item">
                    <div class="tooltip-label">变更待上架</div>
                    <div class="tooltip-value">{{ item.emergencyQty || 0 }}</div>
                  </div>
                  <div class="tooltip-item">
                    <div class="tooltip-label">正常待上架</div>
                    <div class="tooltip-value">{{ item.normalQty || 0 }}</div>
                  </div>
                </div>
                <div class="table-row" :class="{ 'highlight-row': item.storeName === currentStoreName }">
                  <span class="td name">{{ item.storeName }}</span>
                  <span class="td value">{{ item.totalQty }}</span>
                  <span class="td rank">{{ item.rank }}</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="table-box table-box-no-header">
          <div class="panel-content">
            <div class="table-body body-right" v-if="rightTableData.length > 5">
              <el-tooltip
                v-for="item in rightTableData.slice(5, 10)"
                :key="item.rank"
                effect="light"
                placement="top"
                :open-delay="500"
                popper-class="shooting-tooltip"
              >
                <div slot="content" class="tooltip-content">
                  <div class="tooltip-item">
                    <div class="tooltip-label">延期待上架</div>
                    <div class="tooltip-value">{{ item.delayQty || 0 }}</div>
                  </div>
                  <div class="tooltip-item">
                    <div class="tooltip-label">变更待上架</div>
                    <div class="tooltip-value">{{ item.emergencyQty || 0 }}</div>
                  </div>
                  <div class="tooltip-item">
                    <div class="tooltip-label">正常待上架</div>
                    <div class="tooltip-value">{{ item.normalQty || 0 }}</div>
                  </div>
                </div>
                <div class="table-row" :class="{ 'highlight-row': item.storeName === currentStoreName }">
                  <span class="td name">{{ item.storeName }}</span>
                  <span class="td value">{{ item.totalQty }}</span>
                  <span class="td rank">{{ item.rank }}</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import numberImg from '@/assets/images/workbench_img/number.png';
import titleImg from '@/assets/images/workbench_img/title.png';
import iconImg from '@/assets/images/workbench_img/icon.png';

export default {
  name: 'ShootingModule',
  computed: {
    currentStoreName() {
      const store = this.storeTabs.find((item) => item.storeCode === this.storeCode);
      return store ? store.storeName : '';
    },
  },
  data() {
    return {
      activeTab: 0,
      searchForm: {},
      cardsData: [
        { title: '待上架商品总计', value: 0, color: 'text-green' },
        { title: '延期待上架产品', value: 0, color: 'text-yellow' },
        { title: '变更待上架产品', value: 0, color: 'text-orange' },
        { title: '正常待上架产品', value: 0, color: 'text-blue' },
      ],
      gaugeValue: 6,
      leftTableData: [],
      rightTableData: [],
      storeTabs: [],
      numberImg,
      titleImg,
      iconImg,
      storeCode: '',
      loading: false,
    };
  },
  mounted() {
    this.loading = true;
    this.getStroeTab();
    this.initData();
  },
  methods: {
    async initData() {
      this.loading = true;
      await this.newProductUpStatistics();
      await this.rankStore();
      await this.rankGoods();
      this.loading = false;
    },
    handleTabClick(tab, index) {
      this.activeTab = index;
      this.storeCode = tab.storeCode;
      this.initData();
    },
    getStroeTab() {
      const data = new FormData();
      data.append('state', 0);
      this.$q.newProduct.statisticsByStore({ data: data }).then((res) => {
        this.storeTabs = res.data;
        this.storeCode = this.storeTabs[0].storeCode;
        this.initData();
      });
    },
    newProductUpStatistics() {
      const params = {
        params: {
          storeCode: this.storeCode,
        },
      };
      return this.$q.dataBoard.newProductUpStatistics(params).then((res) => {
        this.cardsData[0].value = res.data.totalQty;
        this.cardsData[1].value = res.data.delayQty;
        this.cardsData[2].value = res.data.updateQty;
        this.cardsData[3].value = res.data.normalQty;
      });
    },
    rankStore() {
      let data = {
        pageNum: 1,
        pageSize: 999,
        filterData: {
          storeCode: this.storeCode,
        },
      };
      return this.$q.dataBoard.rankStore({ data }).then((res) => {
        this.leftTableData = res.data.list;
      });
    },
    rankGoods() {
      let data = {
        pageNum: 1,
        pageSize: 999,
        filterData: {
          storeCode: this.storeCode,
        },
      };
      return this.$q.dataBoard.rankGoods({ data }).then((res) => {
        this.rightTableData = res.data.list;
      });
    },
    handleCardClick(row) {
      let data = {
        updateState: '',
        delayStatus: '',
      };
      if (row.title.includes('延期')) {
        data.delayStatus = '0';
      } else if (row.title.includes('变更')) {
        data.updateState = '1';
      } else if (row.title.includes('正常')) {
        data.delayStatus = '1';
        data.updateState = '2';
      }
      this.$router.push({
        path: '/newProduct/newProduct-arrival',
        query: data,
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.workbench-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: url('../../../../assets/images/workbench_img/content.png') no-repeat center;
  background-size: 100% 100%;
  padding-bottom: 20px
  height: 580px;
  gap: 10px;
  margin-top: 10px;
}

.header-row {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 10px
    border-left: 3px solid #95FEFF
    background: linear-gradient(90deg, rgba(0,60,50,0.5) 0%, rgba(0,0,0,0) 100%);
    margin-bottom: 5px;
}

.page-title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 30px;
}

.title-icon {
    height: 20px;
    margin-right: 5px;
}

.main-title {
    font-size: 20px;
    font-family: 'FZLTTH';
    letter-spacing: 1px;
    background: linear-gradient(180deg, #FFFFFF 0%, #B1FFFC 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

.title-decoration {
    margin-left: 10px;
    display: flex;
    align-items: center;
}

.title-decoration-img {
    height: 16px;
    opacity: 0.7;
}

.date-picker-wrapper {
    display: flex;
    align-items: center;
    position: relative;
}

.date-label {
    font-size: 14px;
    color: #D4FFFF;
    margin-right: 10px;
    font-family: PingFangSC;
}

.custom-date-picker {
    width: 220px !important;
    background: transparent !important;
    border: 1px solid #0BB78E !important;
    border-radius: 2px !important;
    padding-right: 30px !important;

    >>> .el-range-input {
        background: transparent !important;
        color: #7BFFE0 !important;
        font-size: 12px;
    }
    >>> .el-range-separator {
        color: #7BFFE0 !important;
        line-height: 22px;
    }
    >>> .el-input__icon {
        display: none;
    }
}

.date-icon-suffix {
    position: absolute;
    right: 10px;
    color: #7BFFE0;
    pointer-events: none;
}

.tab-wrapper {
    display: flex;
    gap: 0;
    margin-left: 10px;
    border: 1px solid rgba(123, 255, 224, 0.3);
    border-radius: 2px;
    background: rgba(123,255,224,0.1);

}

.tab-item {
    padding: 6px 20px;
    background: rgba(5, 72, 56, 0.6);
    color: #8DEDDD;
    font-size: 13px;
    cursor: pointer;
    // border: 1px solid #0BB78E;
    border-right: none;
    transition: all 0.3s ease;
    font-family: 'AlibabaHuiTi', sans-serif;

    &:first-child {
        border-radius: 2px 0 0 2px;
    }

    &:last-child {
        border-radius: 0 2px 2px 0;
    }

    &:hover {
        background: rgba(11, 183, 142, 0.3);
    }

    &.active {
        background: rgba(11, 133, 127, 0.6);
        color: #fff;
        text-shadow: 0px 0px 8px rgba(123,255,224,0.8), 0px 0px 12px rgba(123,255,224,0.5);
    }
}

.cards-row {
    display: flex;
    gap: 10px;
    height: 240px;
    padding: 0 20px
    flex-shrink: 0;
}

.card-item {
    flex: 1;
    position: relative;
    background: rgba(5, 72, 56, 0.6);
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-radius: 4px;
    cursor: pointer;
}

.card-title-row {
    display: flex;
    align-items: center;
    height: 42px;
    background: url('../../../../assets/images/workbench_img/headerBack.png') no-repeat center;
    background-size: 100% 100%;
    padding-left: 10px;
    margin-bottom: 10px;
    position: relative;
    font-family: 'FZLTZHK', sans-serif;
}

.card-title {
    font-size: 14px;
    color: #fff;
    margin-right: 5px;
    font-weight: 500;
}

.help-icon {
    color: rgba(255,255,255,0.5);
    font-size: 14px;
    cursor: pointer;
    margin-right: auto;
}

.card-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
}

.card-number {
    font-family: 'PingFangBold', sans-serif;
    font-size: 40px;
    color: #2EF9C6;
    margin-bottom: 30px;
    font-weight: bold;
}

.text-green { color: #4BEDD2; }
.text-orange { color: #F0714B; }
.text-yellow { color: #FFF6A4; }
.text-blue { color: #54AFFF; }

.card-sub {
    font-size: 14px;
    color: #D4FFFF;
    text-shadow: 1px 2px 4px rgba(3,28,78,0.23);
    font-family: 'AlibabaHuiTi', sans-serif;
}

/* Gauge Card Special Styles */
.gauge-card {
    display: flex;
    flex-direction: column;
}

.gauge-chart-wrapper {
    flex: 1;
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.number-display {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.number-bg {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.number-val {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%); /* Slight adjustment for visual center */
    font-family: 'PingFangBold', sans-serif;
    font-size: 40px;
    color: #fff;
    font-weight: bold;
}

.tables-row {
    flex: 1;
    display: flex;
    gap: 10px;
    min-height: 0;
    padding: 0 20px
}

.table-group {
    flex: 1;
    display: flex;
}

.table-box {
    flex: 1;
    position: relative;
    background: rgba(5, 72, 56, 0.6);
    padding: 0;
    display: flex;
    flex-direction: column;
}

.table-box-with-header {
    border-radius: 4px 0 0 4px;
}

.table-box-no-header {
    border-radius: 0 4px 4px 0;
}

.panel-header {
    display: flex;
    align-items: center;
    height: 42px;
    background: url('../../../../assets/images/workbench_img/headerBox.png') no-repeat center;
    background-size: 100% 100%;
    padding-left: 10px;
    margin-bottom: 0;
    width: calc(20vw - 60px);
    font-family: 'FZLTZHK', sans-serif;
}

.panel-title {
    font-size: 14px;
    margin-right: 5px;
    color: #fff;
}

.panel-content {
    flex: 1;
    overflow: hidden;
    padding: 15px 20px;
    display: flex;
    flex-direction: column;
}

.table-box-no-header .panel-content {
    padding-left: 0;
}

.table-header-row {
    display: flex;
    padding: 8px 0;
    color: #8DEDDD;
    font-size: 14px;
}

.th, .td {
    text-align: center;
}

.th.name, .td.name { flex: 1; text-align: left; padding-left: 15px; }
.th.value, .td.value { flex: 1; }
.th.rank, .td.rank { flex: 1; }

.table-body {
    flex: 1;
    overflow-y: auto;
    padding-top: 5px;
}

.body-right {
  padding-top: 12px
}

.table-row {
    display: flex;
    padding: 8px 0;
    font-size: 14px;
    color: #fff;
    /* 保留左右边框，只去掉行与行之间的顶部重叠 */
    border-bottom: 1px solid #1D6052;
    border-left: 1px solid #1D6052;
    border-right: 1px solid #1D6052;
    background: #0B5042;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      cursor: pointer
      // background: rgba(11, 133, 127, 0.6)
    }
}

.highlight-row {
  background: rgba(11, 133, 127, 0.6) !important;
}

.table-box .table-body .table-row:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.table-box .table-body .table-row:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}

::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}
::-webkit-scrollbar-track {
    background: rgba(255,255,255,0.02);
}
::-webkit-scrollbar-thumb {
    background: rgba(46, 249, 198, 0.2);
    border-radius: 2px;
}
</style>

<style lang="stylus">
.shooting-tooltip {
  .tooltip-content {
    display: flex;
    gap: 20px;
    text-align: center;
  }
  .tooltip-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .tooltip-label {
    font-size: 12px;
    color: #333;
    margin-bottom: 5px;
  }
  .tooltip-value {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
</style>
